"use strict";

var diagnostics = {
  trace: trace,
  enabled: false,
  devtoolsEnabled: false };

module.exports = diagnostics;

function trace() {
  if (diagnostics.enabled) {
    console && console.log.apply(console, arguments);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/core/diagnostics.js
// module id = rbxW
// module chunks = 88